import { useState, useEffect } from 'react';
import ChangelogList, { formatDate } from '../components/ChangelogList';

const authHeaders = () => {
    const token = localStorage.getItem('token');
    return token ? { Authorization: `Bearer ${token}` } : {};
};

const STATUS_CONFIG = {
    ok: { dot: 'bg-green-500', label: 'All systems operational', bg: 'bg-green-50 border-green-200 text-green-800' },
    degraded: { dot: 'bg-amber-500', label: 'Degraded performance', bg: 'bg-amber-50 border-amber-200 text-amber-800' },
    outage: { dot: 'bg-red-500', label: 'Service disruption', bg: 'bg-red-50 border-red-200 text-red-800' },
};

export default function Changelog() {
    const [status, setStatus] = useState(null);
    const [entries, setEntries] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const base = process.env.REACT_APP_BACKEND_URL || '';
        Promise.all([
            fetch(`${base}/api/status`).then(r => r.json()),
            fetch(`${base}/api/changelog?limit=100`, { headers: authHeaders() }).then(r => r.json()),
        ]).then(([s, e]) => {
            setStatus(s);
            setEntries(Array.isArray(e) ? e : []);
        }).catch(console.error).finally(() => setLoading(false));
    }, []);

    const cfg = STATUS_CONFIG[status?.level] || STATUS_CONFIG.ok;

    return (
        <div className="min-h-screen bg-background px-4 py-12 max-w-2xl mx-auto">
            <h1 className="text-3xl font-bold text-foreground">Mimique Status</h1>

            {/* Status bar */}
            <div className={`flex items-start gap-3 rounded-xl border px-4 py-3 mt-6 mb-10 ${cfg.bg}`}>
                <span className={`mt-1 inline-block h-2.5 w-2.5 shrink-0 rounded-full ${cfg.dot}`} />
                <div>
                    <p className="font-semibold text-sm">{status?.message || cfg.label}</p>
                    {status?.updated_at && (
                        <p className="text-xs opacity-70 mt-0.5">Updated {formatDate(status.updated_at)}</p>
                    )}
                </div>
            </div>

            <h2 className="text-xl font-semibold text-foreground mb-6">Changelog</h2>

            {/* Entries */}
            {loading ? (
                <div className="flex justify-center py-16">
                    <div className="w-6 h-6 border-2 border-primary border-t-transparent rounded-full animate-spin" />
                </div>
            ) : entries.length === 0 ? (
                <p className="text-stone-500 text-sm text-center py-12">No updates yet.</p>
            ) : (
                <ChangelogList entries={entries} variant="page" />
            )}
        </div>
    );
}
